var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_24)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(1 1)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85893 2.36943C8.77232 2.21854 8.64742 2.09319 8.49686 2.00601C8.3463 1.91884 8.17541 1.87294 8.00143 1.87294C7.82746 1.87294 7.65656 1.91884 7.506 2.00601C7.35544 2.09319 7.23055 2.21854 7.14393 2.36943L1.14406 12.5781C0.744181 13.2588 1.22368 14.1242 2.00156 14.1242H14.0004C14.7783 14.1242 15.2587 13.2579 14.8579 12.5781L8.85893 2.36943ZM7.99968 5.37418C8.46781 5.37418 8.83443 5.77843 8.78718 6.2448L8.48093 9.31343C8.47064 9.43398 8.41548 9.54627 8.32637 9.62811C8.23725 9.70994 8.12067 9.75535 7.99968 9.75535C7.87869 9.75535 7.76211 9.70994 7.67299 9.62811C7.58388 9.54627 7.52872 9.43398 7.51843 9.31343L7.21218 6.2448C7.20118 6.13476 7.21336 6.02363 7.24792 5.91857C7.28248 5.81352 7.33867 5.71687 7.41286 5.63485C7.48705 5.55283 7.57759 5.48726 7.67866 5.44236C7.77973 5.39747 7.88909 5.37424 7.99968 5.37418V5.37418ZM8.00143 10.6242C8.2335 10.6242 8.45605 10.7164 8.62015 10.8805C8.78424 11.0446 8.87643 11.2671 8.87643 11.4992C8.87643 11.7312 8.78424 11.9538 8.62015 12.1179C8.45605 12.282 8.2335 12.3742 8.00143 12.3742C7.76937 12.3742 7.54681 12.282 7.38271 12.1179C7.21862 11.9538 7.12643 11.7312 7.12643 11.4992C7.12643 11.2671 7.21862 11.0446 7.38271 10.8805C7.54681 10.7164 7.76937 10.6242 8.00143 10.6242Z",
    fill: "#005CA9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic-info.4a3221f22cffbac0ac156f08529570a2.svg";
export { ForwardRef as ReactComponent };